var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDropdownIterativeDown = function SvgDropdownIterativeDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.293 17.4142L4.29297 10.4142L5.70718 9L12.0001 15.2929L18.293 9L19.7072 10.4142L12.7072 17.4142C12.3167 17.8047 11.6835 17.8047 11.293 17.4142Z",
    fill: "#767676"
  })));
};
export { SvgDropdownIterativeDown as ReactComponent };
export default __webpack_public_path__ + "assets/4b06e292.svg";